module.exports = __webpack_public_path__ + "static/media/lp-plan-03.7ccd86b3.png";